import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"
import "./ContestInfo.scss"
import { gettext, interpolate } from "@multimediallc/web-utils"
import { useAppContext, useFeatureFlag } from "../../../hooks/appContext"
import { Sizes, Weights } from "../../../interfaces/sizing"
import { Link, Typography } from "../../common"
import ContestHeaderImg from "../images/contest-details-header.png"
import type { IContestAppContext } from "../../../interfaces/contestAppContext"

const i18n = {
    contestHeaderText: (site_name: string): string => {
        return interpolate(
            gettext(
                "EASY MONEY! Each month, %(site_name)s gives $11,000+ in prize money!",
            ),
            { site_name: site_name },
            true,
        )
    },
    everyHourText: (site_name: string): string => {
        return interpolate(
            gettext(
                'Every hour, %(site_name)s will be awarding a $10 prize to the top cam, and $5 to the 2nd place cam, known as "Win $11,000+" contest.',
            ),
            { site_name: site_name },
            true,
        )
    },
    contestDescriptionText: (site_name: string): string => {
        return interpolate(
            gettext(
                'While the other sites only allow any single person to win a maximum of $2,000 per month, <span class="standout">at %(site_name)s, we award over $11,000 in prizes!</span> Also, the other sites only allow up to 16 winners in any given month. %(site_name)s spreads the love and we award prizes to <span class="standout">HUNDREDS OF WINNERS</span> each month. This keeps the contest exciting and flexible and this allows you to make as much $$$ as you want.',
            ),
            { site_name: site_name },
            true,
        )
    },
}

export function ContestInfo() {
    const linguiMigrate = useFeatureFlag("LinguiMigrate").active
    const siteName =
        useAppContext<IContestAppContext>().context.siteName ?? "Chaturbate"
    const siteNameSantitizer = document.createElement("span")
    siteNameSantitizer.innerText = siteName
    const sanitizedSiteName = siteNameSantitizer.innerHTML // eslint-disable-line @multimediallc/no-inner-html

    return (
        <div className="ContestInfo">
            <div className="topSection">
                <Typography
                    weight={Weights.medium}
                    component={Link}
                    href="/contest/details"
                    className="headerTabLink"
                >
                    {t`WIN $11,000+ DETAILS!`}
                </Typography>
            </div>
            <div className="infoSection">
                <div className="contestDescription">
                    <img
                        src={ContestHeaderImg}
                        alt="contest-header"
                        data-testid="promo-image"
                    />
                </div>
                <Typography
                    weight={Weights.medium}
                    className="contentHeaderText"
                    component="h1"
                    size={Sizes.xl}
                >
                    {linguiMigrate
                        ? t`EASY MONEY! Each month, ${siteName} gives $11,000+ in prize money!`
                        : i18n.contestHeaderText(siteName)}
                </Typography>
                <Typography size={Sizes.sm} component="p">
                    {linguiMigrate
                        ? t`Every hour, ${siteName} will be awarding a $10 prize to the top cam, and $5 to the 2nd place cam, known as the "Win $11,000+" contest.`
                        : i18n.everyHourText(siteName)}
                </Typography>
                {linguiMigrate ? (
                    <Typography size={Sizes.sm} component="p">
                        <Trans>
                            While the other sites only allow any single person
                            to win a maximum of $2,000 per month,{" "}
                            <span className="standout">
                                at {siteName}, we award over $11,000 in prizes!
                            </span>{" "}
                            Also, the other sites only allow up to 16 winners in
                            any given month. {siteName} spreads the love and we
                            award prizes to{" "}
                            <span className="standout">
                                HUNDREDS OF WINNERS
                            </span>{" "}
                            each month. This keeps the contest exciting and
                            flexible and this allows you to make as much $$$ as
                            you want.
                        </Trans>
                    </Typography>
                ) : (
                    <Typography
                        size={Sizes.sm}
                        component="p"
                        dangerouslySetInnerHTML={{
                            __html: i18n.contestDescriptionText(
                                sanitizedSiteName,
                            ),
                        }}
                    />
                )}
            </div>
        </div>
    )
}
